// Links de assinatura do Douto. Oferta: primeiro caso grátis + 7 dias de garantia.
// Preços e cupons são validados no Payments Hub, sem alteração de cobrança aqui.
const DOUTO_SUBSCRIBE_URL = 'https://dash.douto.app/';
export const DOUTO_ANNUAL_COUPON = 'DOUTO25ANUAL';

function subscribeUrl(plano, { utm_campaign, utm_content, cupom } = {}) {
  const url = new URL(DOUTO_SUBSCRIBE_URL);
  url.search = new URLSearchParams({
    utm_source: 'minimental',
    utm_medium: 'onboarding',
    utm_campaign: utm_campaign || 'onboarding_douto',
    utm_content: utm_content || plano,
    plano,
    ...(cupom ? { cupom } : {}),
  }).toString();
  return url.toString();
}

export function doutoMonthlyTrialUrl(utm_content) {
  return subscribeUrl('mensal', { utm_content });
}

export function doutoAnnualDiscountUrl(utm_content) {
  return subscribeUrl('anual', { utm_content, cupom: DOUTO_ANNUAL_COUPON });
}

/**
 * Código "pessoal" só de exibição — nunca é o que o checkout do Douto valida (isso
 * continua sendo DOUTO_ANNUAL_COUPON, aplicado pelo link). Determinístico por conta
 * (mesmo seed → mesmo código sempre), sem backend, sem tabela de cupons nova.
 */
export function personalCode(seed) {
  const s = String(seed || 'minimental').trim().toLowerCase() || 'minimental';
  const chars = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ'; // sem I/O: evita confundir com 1/0
  let a = 0, b = 0;
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    a = (a * 31 + c) >>> 0;
    b = (b * 131 + c * 17 + 1) >>> 0;
  }
  let out = '';
  for (let i = 0; i < 16; i++) {
    const mix = (a ^ (b << (i % 7)) ^ (i * 2654435761)) >>> 0;
    out += chars[mix % chars.length];
    a = (a * 1103515245 + 12345) >>> 0;
    b = (b * 48271 + 7) >>> 0;
  }
  return out.match(/.{1,4}/g).join('-');
}
